export default "__VITE_ASSET__DFQxOxtN__"